import React from "react";
import { Helmet } from "react-helmet-async";
import "./Hero.css";
import SmartImage from "../SmartImage";
import mascotaPrincipal from "../../assets/LEON2.webp";
import { FaArrowRight, FaWhatsapp } from "react-icons/fa";
import TrackedContactLink from "../TrackedContactLink";


const Hero = () => {
      return (
        <>
          <Helmet>
            <link rel="preload" as="image" href={mascotaPrincipal} />
          </Helmet>

          <section className="hero" id="inicio">
            <div className="hero__content">
              <div className="hero__copy">
                <span className="hero__badge">AGENCIA DE DISEÑO DIGITAL</span>

                <h1 className="hero__title">
                  Diseñamos personajes,
                  <br />
                  marcas y contenido que
                  <br />
                  hacen que tu negocio
                  <span className="hero__title-accent"> destaque</span>
                </h1>

                <p className="hero__text">
                  Transformamos ideas en diseños memorables. Desde mascotas
                  publicitarias hasta animación y registro de marca, llevamos tu
                  proyecto al siguiente nivel.
                </p>

                <div className="hero__actions">
                  <TrackedContactLink
                    className="hero__btn hero__btn--primary"
                    eventLabel="floating_button"
                    kind="whatsapp"
                  >
                    <FaWhatsapp className="whatsapp-button__icon" />
                    <span>Quiero información</span>
                  </TrackedContactLink>
                  <a href="#portafolio" className="hero__btn hero__btn--secondary">
                    Ver proyectos
                    <FaArrowRight className="hero__btn-icon" />
                  </a>
                </div>
              </div>

              <div className="hero__visual">
                <div className="hero__orb"></div>
                <SmartImage
                  src={mascotaPrincipal}
                  className="hero__lion"
                  alt="Personaje principal"
                  width="508"
                  height="1047"
                  priority
                />
              </div>
            </div>

            <div className="hero__features-bar">
              <div className="hero__features">
                <div className="hero__feature">
                  <span>✦</span>
                  <h4>Diseños 100% personalizados</h4>
                </div>

                <div className="hero__feature">
                  <span>✦</span>
                  <h4>Más de 5 años de experiencia</h4>
                </div>

                <div className="hero__feature">
                  <span>✦</span>
                  <h4>Entregas a tiempo y profesionales</h4>
                </div>

                <div className="hero__feature">
                  <span>✦</span>
                  <h4>Asesoría creativa en todo el proceso</h4>
                </div>
              </div>
            </div>
          </section>
        </>
      );
};

export default Hero;
